<template>
  <v-container>
    <v-card>
      <v-card-title class="title subprimary">
        <v-spacer></v-spacer>
        Текущий диссертационный совет
        <v-spacer></v-spacer>
      </v-card-title>

      <LDissertation_council_member v-bind:isDetail="true"></LDissertation_council_member>
      <LDissertation_council_scientific_field  v-bind:isDetail="true"> </LDissertation_council_scientific_field>
    </v-card>
  </v-container>
</template>

<script>
    import urls from "../../../modules/petition/urls"
    import UserDataMixin from '../../../mixins/UserDataMixin'
    import {makeGetRequest} from "../../../helper";
    import LDissertation_council_member from "../../../modules/diss/pages/adminPage/page/ListDissertation_council_member"
    import LDissertation_council_scientific_field from "../../../modules/diss/pages/adminPage/page/ListDissertation_council_scientific_field"

    export default {
        name: "ListDissertation_council_member",
        mixins: [UserDataMixin],
        components:{
            LDissertation_council_member,
            LDissertation_council_scientific_field
        },
        data () {
            return {

            }
        },


        created() {

            this.$store.commit('mainpage/changeTitle', 'Диссертационный совет');
        },
        methods: {

        }
    }


</script>
<style scoped>

</style>
